import { UserFormGuestDetails } from '@/app/pages/user-form/user-form-guest-details';
import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

export const Route = createFileRoute('/user-form/guest-details')({
  validateSearch: z.object({
    travelId: z.string().uuid(),
  }),
  component: UserFormGuestDetails,
});
